
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import AllProductsTab from "./product-management/AllProductsTab";
import AddNewProductTab from "./product-management/AddNewProductTab";
import BulkUploadTab from "./product-management/BulkUploadTab";
import SyncStatusTab from "./product-management/SyncStatusTab";
import { useNetworkStatus } from "@/contexts/NetworkStatusContext";

const ProductManagement = () => {
  const { isOnline } = useNetworkStatus();
  
  return (
    <div className="space-y-4">
      <h1 className="text-3xl font-bold text-green-700">Product Management</h1>
      <p className="text-muted-foreground">
        Manage your product inventory, categories, pricing, and more.
        {!isOnline && (
          <span className="ml-2 text-amber-500 font-medium">
            (Offline Mode - Changes will sync when connection is restored)
          </span>
        )}
      </p>
      
      <Tabs defaultValue="all-products" className="w-full">
        <TabsList className="grid grid-cols-4 mb-4 bg-green-100 p-1">
          <TabsTrigger 
            value="all-products" 
            className="data-[state=active]:bg-green-600 data-[state=active]:text-white"
          >
            All Products
          </TabsTrigger>
          <TabsTrigger 
            value="add-new" 
            className="data-[state=active]:bg-green-600 data-[state=active]:text-white"
          >
            Add New
          </TabsTrigger>
          <TabsTrigger 
            value="bulk-upload" 
            className="data-[state=active]:bg-green-600 data-[state=active]:text-white"
          >
            Bulk Upload
          </TabsTrigger>
          <TabsTrigger 
            value="sync-status" 
            className="data-[state=active]:bg-green-600 data-[state=active]:text-white"
          >
            Sync Status
          </TabsTrigger>
        </TabsList>
        
        <Card className="border-green-100">
          <CardContent className="p-6">
            <TabsContent value="all-products" className="mt-0">
              <AllProductsTab />
            </TabsContent>
            
            <TabsContent value="add-new" className="mt-0">
              <AddNewProductTab />
            </TabsContent>
            
            <TabsContent value="bulk-upload" className="mt-0">
              <BulkUploadTab />
            </TabsContent>
            
            <TabsContent value="sync-status" className="mt-0">
              <SyncStatusTab />
            </TabsContent>
          </CardContent>
        </Card>
      </Tabs>
    </div>
  );
};

export default ProductManagement;
